import { Types } from '@store/types';

const initialState = [];

const CompositionReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.FETCH_COMPOSITION_LIST:
			return [...initialState, ...action.payload.data];
		default:
			return state;
	}
};

export default CompositionReducer;
